import localStorage from 'common/helpers/getters/localStorage'


type HandlerValues = {
  storageName: string
  isSessionStorage?: boolean
  position?: 'FIRST' | 'LAST' // add to begin or to the end, similar to addToQueue api
  metadata?: {
    placement: string
    recommenderName?: string
  }
}

type Product = {
  id: number
  name: string
  brand: string
  image: string
  typeGroup: string
}

const createToggleStorageProductHandler = ({ storageName, isSessionStorage, metadata, position = 'LAST' }: HandlerValues) => (
  (product: Product) => {
    const { id } = product

    const [ setAction, getAction ] = [
      isSessionStorage ? localStorage.setSessionItem : localStorage.setItem,
      isSessionStorage ? localStorage.getSessionItem : localStorage.getItem,
    ].map((func) => func.bind(localStorage))

    const { items: products = [] } = getAction(storageName, {})
    const isSelected = products.map(({ id }) => id).includes(id)

    let selectedProducts

    if (isSelected) {
      selectedProducts = products.filter(({ id: selectedProductId }) => selectedProductId !== id)
    }
    else {
      selectedProducts = position === 'FIRST'
        ? [ product ].concat(products)
        : products.concat(product)
    }

    setAction(storageName, { items: selectedProducts, metadata })

    return {
      isSelected,
      selectedProducts,
    }
  }
)


export default createToggleStorageProductHandler
